import { mesh2ndRect } from "./mesh2ndRect";
import { mesh3rdRect } from "./mesh3rdRect";
import { mesh4thRect } from "./mesh4thRect";

// ===== slot管理（Cesiumのpropertiesは使わない） =====
const bumpSlotGen = (slot) => {
  slot.__csvGen = (slot.__csvGen || 0) + 1;
  return slot.__csvGen;
};
const getSlotGen = (slot) => slot.__csvGen || 0;

const clearSlotChildren = (viewer, slot) => {
  if (!viewer || !slot) return;
  const children = slot.__csvChildren;
  if (Array.isArray(children)) {
    for (const ent of children) {
      try {
        viewer.entities.remove(ent);
      } catch {
        //
      }
    }
  }
  slot.__csvChildren = [];
};

const addChildToSlot = (viewer, slot, child) => {
  if (!viewer || !slot || !child) return;

  // ぶら下げ（これ自体は任意だけど、管理しやすくなる）
  child.parent = slot;

  viewer.entities.add(child);

  if (!Array.isArray(slot.__csvChildren)) slot.__csvChildren = [];
  slot.__csvChildren.push(child);
};

// ===== CSV =====
const fetchCombinedCsv = async (urls) => {
  const texts = await Promise.all(
    urls.map(async (url) => {
      const r = await fetch(url);
      if (!r.ok) throw new Error(`HTTP ${r.status} ${url}`);
      return await r.text();
    })
  );
  return texts.join(""); // 元コード互換
};

const parseCsvTo2D = (csvText) => {
  const rows = csvText.split("\r\n");
  return rows.map((line) => line.split(","));
};

const pickStyle = (metadata, ratio1set, alpha1set, color1set, shikii1set, isKokudo) => {
  const shikii1 = Number(shikii1set?.[0] ?? (isKokudo ? metadata.kokudo_shikii1 : metadata.shikii1) ?? 0);
  const shikii2 = Number(shikii1set?.[1] ?? (isKokudo ? metadata.kokudo_shikii2 : metadata.shikii2) ?? 0);
  const shikii3 = Number(shikii1set?.[2] ?? (isKokudo ? metadata.kokudo_shikii3 : metadata.shikii3) ?? 0);
  const shikii4 = Number(shikii1set?.[3] ?? (isKokudo ? metadata.kokudo_shikii4 : metadata.shikii4) ?? 0);

  const hanrei1_color = (color1set?.[0] ?? metadata.hanrei1_color) || "";
  const hanrei2_color = (color1set?.[1] ?? metadata.hanrei2_color) || "";
  const hanrei3_color = (color1set?.[2] ?? metadata.hanrei3_color) || "";
  const hanrei4_color = (color1set?.[3] ?? metadata.hanrei4_color) || "";
  const hanrei5_color = (color1set?.[4] ?? metadata.hanrei5_color) || "";

  return {
    shikii1, shikii2, shikii3, shikii4,
    hanrei1_color, hanrei2_color, hanrei3_color, hanrei4_color, hanrei5_color,
    ratio: Number(ratio1set),
    alpha: Number(alpha1set),
  };
};

export const csvfecth = (
  rfcs,
  dataname,
  no,
  year,
  area,
  csv_name,
  year1_nihonsokuchi,
  metadata,
  ratio1set,
  alpha1set,
  color1set,
  shikii1set,
  checkflag
) => {
  console.log("[csvfecth] called", {
    modeset: window.__dbg_mode, // 後述（任意）
    metaNo: metadata?.no,
    year,
    area,
    csv_name,
    slotId: dataname?.id,
    slotShow: dataname?.show,
  });

  const viewer = rfcs?.current?.cesiumElement;
  if (!viewer || !dataname || !metadata) return;

  // ここで「前回の子」を消す（slot固定方式の肝）
  clearSlotChildren(viewer, dataname);

  // “後着”対策：この呼び出し世代
  const myGen = bumpSlotGen(dataname);

  const areaarr = area.includes("&") ? area.split("&") : [area];
  const urls = areaarr.map((areai) => `/csv/${metadata.no}/${areai}_${csv_name}_${year}.csv`);

  fetchCombinedCsv(urls)
    .then((csvText) => {
      // 古い結果なら捨てる
      if (getSlotGen(dataname) !== myGen) return null;
      return parseCsvTo2D(csvText);
    })
    .then((meshdata) => {
      if (!meshdata) return;

      if (!meshdata?.[0]?.[0] || String(meshdata[0][0]).startsWith("<")) return;

      const code = String(meshdata[0][0]);
      const codeLen = code.length;

      // 空行除去
      const rows = meshdata.filter((r) => Array.isArray(r) && r.length > 1 && r[0]);

      if (codeLen === 6) {
        const min = Number(metadata.kokudo_min);
        const style = pickStyle(metadata, ratio1set, alpha1set, color1set, shikii1set, true);

        for (let i = 0; i < rows.length; i++) {
          if (Number(rows[i][1]) > min) {
            const child = mesh2ndRect(
              rows[i][0], rows[i][1], rows[i][2],
              dataname, undefined,
              style.shikii1, style.shikii2, style.shikii3, style.shikii4,
              style.hanrei1_color, style.hanrei2_color, style.hanrei3_color, style.hanrei4_color, style.hanrei5_color,
              style.ratio, style.alpha,
              metadata.kokudo_ratio,
              year1_nihonsokuchi
            );
            addChildToSlot(viewer, dataname, child);
          }
        }
        return;
      }

      if (codeLen === 8) {
        const min = Number(metadata.min);
        const style = pickStyle(metadata, ratio1set, alpha1set, color1set, shikii1set, false);

        let hit = 0;
        rows.forEach((data) => {
          if (Number(data[1]) > min) {
            const child = mesh3rdRect(
              data[0], data[1], data[2],
              dataname, undefined,
              style.shikii1, style.shikii2, style.shikii3, style.shikii4,
              style.hanrei1_color, style.hanrei2_color, style.hanrei3_color, style.hanrei4_color, style.hanrei5_color,
              style.ratio, style.alpha,
              metadata.ratio,
              year1_nihonsokuchi
            );
            addChildToSlot(viewer, dataname, child);
            hit++;
          }
        });

        if (!hit) {
          setTimeout(() => window.alert("この地域には閾値以上のデータがありません。"), 3000);
        }
        return;
      }

      if (codeLen === 9) {
        const min = Number(metadata.min);
        const style = pickStyle(metadata, ratio1set, alpha1set, color1set, shikii1set, false);

        for (let i = 0; i < rows.length; i++) {
          if (Number(rows[i][1]) > min) {
            const child = mesh4thRect(
              rows[i][0], rows[i][1], rows[i][2],
              dataname, undefined,
              style.shikii1, style.shikii2, style.shikii3, style.shikii4,
              style.hanrei1_color, style.hanrei2_color, style.hanrei3_color, style.hanrei4_color, style.hanrei5_color,
              style.ratio, style.alpha,
              metadata.ratio,
              year1_nihonsokuchi
            );
            addChildToSlot(viewer, dataname, child);
          }
        }
      }
    })
    .catch((e) => {
      // ★ここを黙殺しない（原因特定のため）
      console.warn("[csvfecth] fetch failed", e, { year, area, csv_name, urls });
      // 失敗時は「消したまま」になるので、必要ならここで復旧方針も可能
    });
};
